import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { isPartialDate } from 'neuro-utils';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';
import { sortDocuments } from 'Utility/randomUtil';

const fm = (id: string, values?: { [key: string]: string | number | null }, key?: string): React.JSX.Element => (
  <FormattedMessage id={id} values={values} key={key} />
);

const categories: Array<{ name: string; items: Array<keyof IChecklist> }> = [
  {
    name: 'medicationTile',
    items: [
      'medicationInhaler',
      'medicationInhalerTechniqueChecked',
      'medicationOralOpioidPrescription',
      'medicationOtherSymptomatic',
      'medicationOther',
    ],
  },
  {
    name: 'weightControlTile',
    items: ['weightControlOverOrUnderWeight', 'weightControlInstructionsGiven'],
  },
  {
    name: 'treatmentsTile',
    items: [
      'treatmentsLivingWillFormGiven',
      'treatmentsPolicyNeeded',
      'treatmentsPolicyDone',
      'treatmentsPalliativePolicyDiscussed',
      'treatmentsPalliativePolicyInformed',
    ],
  },
  {
    name: 'instructionalLeafletTile',
    items: ['instructionalLeafletGiven'],
  },
  {
    name: 'specialConsultationTile',
    items: ['specialConsultationNeeded', 'specialConsultationContactsGiven'],
  },
  {
    name: 'futureVisitsTile',
    items: ['futureVisitsNotNeededBadHealth', 'futureVisitsCancelled'],
  },
];

const getValue = (items: Array<keyof IChecklist>, document: IDocumentWithTypeV2<'checklist'>) => {
  const total = items.length;

  const filled = items.filter(i =>
    i === 'treatmentsPolicyDone' || i === 'specialConsultationContactsGiven'
      ? document[i] && Array.isArray(document[i]) && document[i].length > 0
      : document[i],
  );
  return `${filled.length} / ${total}`;
};

const ChecklistDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const sortedDocs = documents.toSorted((n1, n2) => sortDocuments([{ type: 'date', sortField: 'date' }])(n1, n2));

  const recentDoc = sortedDocs.length > 0 && sortedDocs[0];

  return (
    <>
      {recentDoc && (
        <TileContentMaker
          type="bigHeaderInfo"
          bigHeaderText={isPartialDate(recentDoc.date) ? formatPartialDate(recentDoc.date) : ''}
          data={categories.map(c => ({
            title: fm('checklist.' + c.name),
            value: getValue(c.items, recentDoc),
            key: c.name,
          }))}
        />
      )}
    </>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'checklist'>[];
}

export default ChecklistDash;
